export default __webpack_public_path__ + "static/media/close-icon-gray.ec550122.svg";